import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Icon, Link, Text
} from 'components/ui';
import { colors, space } from 'style/config';

const styles = {
    card: {
        backgroundColor: colors.white,
        borderRadius: 0,
        boxShadow: 'none',
        padding: 0,
        borderBottom: `1px solid ${colors.lightGray}`
    },
    row: {
        borderTop: `1px solid ${colors.lightGray}`,
        paddingTop: space[4],
        paddingBottom: space[4]
    }
};

/**
 * Renders the BI History program links section.
 *
 * @param {Object} props
 * @param {Object} props.section Program links presentation data.
 * @param {Array} props.section.links Link items with id, label, href, and optional action callback.
 * @returns {React.ReactElement} Program links list for FAQ and terms content.
 */
const HistoryProgramLinksSection = ({ section }) => (
    <Box
        marginTop={[4, 5]}
        css={styles.card}
        data-testid='history-program-links-section'
    >
        {section.links.map(link => (
            <Link
                key={link.id}
                href={link.href}
                onClick={link.action}
                color='black'
                display='block'
            >
                <Flex
                    alignItems='center'
                    justifyContent={['space-between', 'flex-start']}
                    gap={[0, 2]}
                    css={styles.row}
                >
                    <Text children={link.label} />
                    <Icon
                        name='chevronRight'
                        size={16}
                    />
                </Flex>
            </Link>
        ))}
    </Box>
);

HistoryProgramLinksSection.propTypes = {
    section: PropTypes.shape({
        title: PropTypes.string,
        links: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                href: PropTypes.string,
                action: PropTypes.func
            })
        ).isRequired
    }).isRequired
};

export default wrapFunctionalComponent(HistoryProgramLinksSection, 'HistoryProgramLinksSection');
